export const formatPrice = (price: string | number): string => {
  if (price === undefined || price === null) return "";
  const num = typeof price === 'string' ? parseInt(price.replace(/[^0-9]/g, ""), 10) : price;
  if (isNaN(num)) return typeof price === 'string' ? price : String(price);
  return `₹${num.toLocaleString('en-IN')}`;
};

export const getLaunchText = (dropDate: string) => {
  if (!dropDate) return "";
  return dropDate;
};

let lastHeroCtaClick = 0;

export const trackEvent = (eventName: string, eventParams: Record<string, any> = {}) => {
  if (eventName === "click_hero_cta") {
    const now = Date.now();
    if (now - lastHeroCtaClick < 1000) return;
    lastHeroCtaClick = now;
  }
  if (typeof window !== "undefined") {
    try {
      window.dataLayer = window.dataLayer || [];
      
      // Push flat event object for GTM/Windsor/custom dataLayer listeners
      window.dataLayer.push({
        event: eventName,
        ...eventParams
      });

      // Maintain standard gtag support
      if (!window.gtag) {
        window.gtag = function () {
          (window.dataLayer as any).push(arguments);
        } as any;
      }
      if (typeof window.gtag === "function") {
        window.gtag("event", eventName, eventParams);
      }
    } catch (e) {
      console.warn("Analytics trackEvent failed", e);
    }
  }
};

export const trackEcommerceEvent = (eventName: string, product: any, extraParams: Record<string, any> = {}) => {
  if (!product) return;
  const priceNum = extraParams.value !== undefined ? extraParams.value : (typeof product.price === "string" ? parseFloat(product.price.replace(/[^0-9.]/g, "")) : (product.price || 0));
  
  const { value, ...restParams } = extraParams;

  const eventParams = {
    currency: "INR",
    value: priceNum,
    items: [
      {
        item_id: product.id?.toString(),
        item_name: product.name,
        price: priceNum,
        quantity: 1
      }
    ],
    ...restParams
  };
  trackEvent(eventName, eventParams);

  if (typeof window !== "undefined" && (window as any).fbq) {
    if (eventName === "view_item") {
      (window as any).fbq("track", "ViewContent", {
        content_name: product.name,
        content_ids: [product.id?.toString()],
        content_type: "product",
        value: priceNum,
        currency: "INR"
      });
    } else if (eventName === "begin_checkout") {
      (window as any).fbq("track", "InitiateCheckout", {
        content_name: product.name,
        content_ids: [product.id?.toString()],
        content_type: "product",
        value: priceNum,
        currency: "INR"
      });
    }
  }
};
